const DEFAULT_RETURN_TO = "/app";

function hasControlCharacters(value: string): boolean {
  return Array.from(value).some((character) => {
    const code = character.charCodeAt(0);
    return code <= 31 || code === 127;
  });
}

export function safeReturnTo(value: unknown, fallback = DEFAULT_RETURN_TO): string {
  if (
    typeof value !== "string" ||
    !value.startsWith("/") ||
    value.startsWith("//") ||
    value.includes("\\") ||
    hasControlCharacters(value)
  )
    return fallback;

  try {
    const parsed = new URL(value, "https://topzle.local");
    if (parsed.origin !== "https://topzle.local") return fallback;
    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return fallback;
  }
}

export function signInPath(returnTo: string): string {
  const search = new URLSearchParams({ returnTo: safeReturnTo(returnTo) });
  return `/sign-in?${search.toString()}`;
}

export function guestSetupPath(returnTo: string): string {
  const search = new URLSearchParams({ guestSetup: "1", returnTo: safeReturnTo(returnTo) });
  return `/settings?${search.toString()}`;
}
